import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 500px;
  padding: 5px;
  @media ${devices.phoneS} {
    min-width: auto;
  }
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ActualEmailContainer = styled(InputRow)`
  padding: 5px 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.container};
  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-right: 5px;
    flex: 1;
    & h3 {
      margin: 0;
      font-size:0.85rem;
      color:${({ theme }) => theme.inputLabel};
      font-weight: bold;
    }
  }
  & button svg {
    height: 14px;
    width: 14px;
    margin: 0 0 0 5px;
  }
`;
